module.exports = __webpack_public_path__ + "media/images/writer/home/icon-illust-558b541860d2d87ba8b910e3d440de3a.svg";